var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadChange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_128_2",
    "data-name": "Componente 128 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.99,
    height: 126.99,
    viewBox: "0 0 126.99 126.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_32",
    "data-name": "Trazado 32",
    d: "M63.495,0A63.495,63.495,0,1,1,0,63.495,63.495,63.495,0,0,1,63.495,0Z",
    fill: "rgba(97,97,97,0.05)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud_sync_black_24dp",
    transform: "translate(24.789 24.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1539",
    "data-name": "Grupo 1539",
    transform: "translate(-0.133 -0.133)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_604",
    "data-name": "Rect\\xE1ngulo 604",
    width: 76,
    height: 76,
    transform: "translate(0.344 0.344)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1541",
    "data-name": "Grupo 1541",
    transform: "translate(12.718 12.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1540",
    "data-name": "Grupo 1540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_490",
    "data-name": "Trazado 490",
    d: "M67.733,46.956a7.97,7.97,0,0,1-7.967,7.967l-20.713.064a9.534,9.534,0,0,1-.51-19.056,11.1,11.1,0,0,1,21.064,3.091c.064,0,.1-.032.159-.032A7.97,7.97,0,0,1,67.733,46.956Zm-44.613-7.9a3.187,3.187,0,1,0-6.373,0v4.589a19,19,0,0,1,4.461-31.357A3.432,3.432,0,0,0,23.12,9.194a3.07,3.07,0,0,0-4.366-2.8A25.422,25.422,0,0,0,12.7,48.613H7.187a3.187,3.187,0,1,0,0,6.373H19.933A3.2,3.2,0,0,0,23.12,51.8ZM51.8,10.373A3.187,3.187,0,1,0,51.8,4H39.053a3.2,3.2,0,0,0-3.187,3.187V19.933a3.187,3.187,0,1,0,6.373,0V15.344a19.357,19.357,0,0,1,6.118,10.962H54.8a25.431,25.431,0,0,0-8.476-15.933Z",
    transform: "translate(-4 -4)",
    fill: "#3264dc"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadChange);
export default __webpack_public_path__ + "static/media/uploadChange.683cac031dfb0128e276b4fb0e70ead6.svg";
export { ForwardRef as ReactComponent };